module.exports = __webpack_public_path__ + "static/media/connection-error.e5026b24.png";